const PROVIDER_HOST = process.env.REACT_APP_OAUTH_PROVIDER_HOST
const BASE_URL = process.env.REACT_APP_BASE_URL
const CLIENT_ID = process.env.REACT_APP_OAUTH_CLIENT_ID

export const OAUTH_REDIRECT_URL = `${BASE_URL}/login/oauth`

const UTM_PARAMETERS = [
  { key: 'utmSource', param: 'utm_source' },
  { key: 'utmCampaign', param: 'utm_campaign' },
  { key: 'utmMedium', param: 'utm_medium' },
  { key: 'utmTerm', param: 'utm_term' },
  { key: 'utmContent', param: 'utm_content' },
  { key: 'utmId', param: 'utm_id' },
]

const computeOrigin = (searchParams) => {
  if (localStorage.getItem('communityId')) {
    return 'invitation'
  } else if (localStorage.getItem('redirectUrl')) {
    return 'program_registration'
  } else if (searchParams.get('utm_source')) {
    return 'campaign'
  }

  return null
}

const extractUtmParams = (searchParams) => (
  Object.fromEntries(UTM_PARAMETERS.map(({ key, param }) => [key, searchParams.get(param)]).filter(([, value]) => value))
)

export const buildOAuthState = (segment = null, communityId = null, origin = null, utmParams = {}) =>
  JSON.stringify({
    ...(segment && { segment }),
    ...(communityId && { communityId }),
    ...(origin && { origin }),
    ...utmParams,
  })

export const buildSignInUrl = (communityId = null, searchParams = new URLSearchParams()) => {
  const origin = computeOrigin(searchParams)
  const utmParams = extractUtmParams(searchParams)
  const params = new URLSearchParams({
    client_id: CLIENT_ID,
    redirect_uri: OAUTH_REDIRECT_URL,
    response_type: 'code',
    scope: 'openid username',
    state: buildOAuthState(null, communityId, origin, utmParams),
  })
  return `${PROVIDER_HOST}/oauth/authorize?${params.toString()}`
}

export const buildSignUpUrl = (segment, communityId = null, searchParams = new URLSearchParams()) => {
  const origin = computeOrigin(searchParams)
  const utmParams = extractUtmParams(searchParams)
  const params = new URLSearchParams({
    client_id: CLIENT_ID,
    redirect_uri: OAUTH_REDIRECT_URL,
    response_type: 'code',
    scope: 'openid username',
    state: buildOAuthState(segment, communityId, origin, utmParams),
  })
  return `${PROVIDER_HOST}/auth/sign_up?${params.toString()}`
}
